<template>
  <div>

    <br />
    <h5 class="pageTitle">Activation du compte membre</h5>
    <p>
      Afin de compléter l'activation de votre compte, veuillez entrer votre mot de passe 2 fois, puis cliquer sur le bouton 'Activer' en bas de la page.
    </p>

    <br />

    <reset-password-form @valid="passwordValidated" :button-text="'Activer mon compte COQ'" />

    <br />

    <template v-if="errorsBackend.length > 0">
      <span v-for="error in errorsBackend" class="error" style="padding-left: 10px">{{ error }}</span>
    </template>

  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import resetPasswordForm from '../../components/Connexion/Connexion_Reinitialisation_Mot_de_passe';

  export default {
    name: 'activation-membre-existant',
    components: { resetPasswordForm },
    data() {
      return {
        errorsBackend: []
      };
    },
    methods: {
      ...mapActions('account', [ 'resetPassword' ]),

      passwordValidated(data) {
        this.errorsBackend = [];
        data['token'] = this.$route.query.token;

        this.resetPassword(data)
          .then(success => {
            this.$swal({
              title: 'Mot de passe',
              text: 'Votre compte a été activé avec succès. Vous pouvez maintenant vous connecter afin d\'ajouter un mode de paiement pour le renouvellement de votre adhésion au Club.',
              confirmButtonText: 'Fermer'
            }).then(result => {
              this.$router.push({ name: 'LoginPage' });
            });
          })
          .catch(error => {
            this.errorsBackend.push(error);
          });
      }
    }
  };
</script>

<style scoped>
.error {
  color: #dc3545;
}
</style>
